<template>
    <div>
        <div class="newCategoriesSlider__skeleton" v-if="getIsLoadingEpg">
            <div
                class="newCategoriesSlider__skeleton__item"
                v-for="i in 10"
            ></div>
        </div>
        <div class="newCategoriesSlider" v-if="!getIsLoadingEpg">
            <div class="newCategoriesSlider__wrapper">
                <div
                    class="swiper-button swiper-button-prev swiper-button-prev-categoty"
                    ref="caregoryToPrev"
                >
                    <div class="swiper-button--item">
                        <IArr />
                    </div>
                </div>
                <div
                    class="mainChanelContent__timeShift_controls_swiper"
                    v-if="activeSlideIndex !== null"
                >
                    <swiper
                        :slidesPerView="'auto'"
                        :initialSlide="activeSlideIndex"
                        :mousewheel="true"
                        :free-mode="true"
                        :modules="modules"
                        :navigation="{
                            prevEl: caregoryToPrev,
                            nextEl: caregoryToNext,
                        }"
                        :spaceBetween="10"
                        @swiper="swiper"
                        ref="mySwiper"
                        class="mySwiper"
                    >
                        <swiper-slide
                            class="newCategoriesSlider__item"
                            v-for="(category, index) in days"
                            :key="category.id"
                            @click="slideToSlide(index)"
                        >
                            <ElButton
                                size="small"
                                :type="
                                    category == currentDay ? 'default' : 'grey'
                                "
                                @click="clickEpg(category, index)"
                            >
                                <p class="weekday">
                                    {{ convertToWeekDays(category) }}
                                    <span class="date"> {{ category }} </span>
                                </p>
                            </ElButton>
                        </swiper-slide>
                    </swiper>
                </div>
                <div
                    class="swiper-button swiper-button-next swiper-button-next-categoty"
                    ref="caregoryToNext"
                >
                    <div class="swiper-button--item">
                        <IArr />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from "vue";
import ElButton from "../ElButton/index.vue";
import IBannerSwiper from "../../components/Icons/IBannerSwiper.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import IArr from "./icons/iArr.vue";
import { Navigation, Mousewheel, FreeMode } from "swiper/modules";
import "swiper/css";
import { mapGetters } from "vuex";
export default {
    name: "NewCategoriesSlider",
    components: {
        IBannerSwiper,
        Swiper,
        SwiperSlide,
        ElButton,
        IArr,
    },
    props: ["isLoggedIn", "days", "currentDay", "activeSlideIndex", "isShow"],
    emits: ["clickEpg"],
    data() {
        return {
            scrollleft: null,
            swiperInstance: null,
        };
    },
    watch: {
        isShow(value) {
            if (!value) return;
            this.goToCurrentDay();
        },
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        },
        currentLang() {
            return this.$i18n.locale === "ru" ? "" : "uz";
        },
        ...mapGetters(["getIsLoadingEpg"]),
    },

    setup() {
        const caregoryToPrev = ref(null);
        const caregoryToNext = ref(null);
        return {
            modules: [Navigation, Mousewheel, FreeMode],
            caregoryToPrev,
            caregoryToNext,
        };
    },

    methods: {
        slideToSlide(index) {
            this.swiperInstance.slideTo(index - 1, 1000, false);
        },
        swiper(swiper) {
            this.swiperInstance = swiper;
            this.slideToSlide(this.activeSlideIndex);
        },
        convertToWeekDays(string) {
            const locale = this.$i18n.locale;
            const daysRu = [
                "Воскресенье",
                "Понедельник",
                "Вторник",
                "Среда",
                "Четверг",
                "Пятница",
                "Суббота",
            ];
            const daysUz = [
                "Yakshanba",
                "Dushanba",
                "Seshanba",
                "Chorshanba",
                "Payshanba",
                "Juma",
                "Shanba",
            ];

            const newString = string.replaceAll(".", "-");
            const date = new Date();
            const year = date.getFullYear();
            const currentDate = new Date(`${year}-${newString}`);

            const isSameDay = (d1, d2) =>
                d1.toDateString() === d2.toDateString();
            const yesterday = new Date(date);
            const tomorrow = new Date(date);
            yesterday.setDate(date.getDate() - 1);
            tomorrow.setDate(date.getDate() + 1);

            if (isSameDay(date, currentDate)) {
                return locale === "ru" ? "Сегодня" : "Bugun";
            }
            if (isSameDay(yesterday, currentDate)) {
                return locale === "ru" ? "Вчера" : "Kecha";
            }
            if (isSameDay(tomorrow, currentDate)) {
                return locale === "ru" ? "Завтра" : "Ertaga";
            }

            const dayIndex = currentDate.getDay();
            return locale === "ru" ? daysRu[dayIndex] : daysUz[dayIndex];
        },
        convertToMonth(number) {
            const months = {
                ru: [
                    "января",
                    "февраля",
                    "марта",
                    "апреля",
                    "мая",
                    "июня",
                    "июля",
                    "августа",
                    "сентября",
                    "октября",
                    "ноября",
                    "декабря",
                ],
                default: [
                    "yanvar",
                    "fevral",
                    "mart",
                    "aprel",
                    "may",
                    "iyun",
                    "iyul",
                    "avgust",
                    "sentabr",
                    "oktabr",
                    "noyabr",
                    "dekabr",
                ],
            };
            const locale = this.$i18n.locale === "ru" ? "ru" : "default";
            return months[locale][number - 1];
        },

        convertToDate(date) {
            const [month, day] = date.split(".").map(Number);
            return `${day} ${this.convertToMonth(month)}`;
        },
        clickEpg(item, index) {
            this.$emit("clickEpg", item, index);
        },
        goToCurrentDay() {
            this.slideToSlide(this.activeSlideIndex);
        },
    },
};
</script>

<style lang="scss">
@import "./styles/categories.scss";
</style>
